import { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Footer } from '../../containers';
import './reset-password.css';
import { useTranslation } from 'react-i18next';
import api from '../../api/axios';

const ResetPassword = () => {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();

    const { token } = useParams(); // <-- this gets the token from URL
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    useEffect(() => {
        // Scroll to top on page load
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        if (newPassword !== confirmPassword) {
            setError('Die Passwörter stimmen nicht überein.');
            return;
        }

        try {
            const response = await api.post(`/user/api/reset-password/${token}`, {
                password: newPassword
            });

            setSuccess('Passwort wurde erfolgreich zurückgesetzt. Du wirst jetzt weitergeleitet...');
            setTimeout(() => navigate('/'), 3000);
        } catch (err) {
            const message = err.response?.data?.message || 'Fehler beim Zurücksetzen des Passworts.';
            if (err.response) {
                setError(message);
            } else {
                setError('Serverfehler. Bitte versuche es später erneut.');
            }
            console.error(err);
        }
    };

    return (
        <div className='wrapper-myevents'>

            <div className='myevents-site'>
                <div className="myevents-content-parent">
                    <form onSubmit={handleSubmit}>
                        <label for="newPassword">{t('NewPassword')}</label>
                        <input
                            id="newPassword"
                            type="password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            required />
                        <label for="confirmNewPassword">{t('ConfirmNewPassword')}</label>
                        <input
                            id="confirmNewPassword"
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required />
                        {error && <p style={{ color: 'red' }}>{error}</p>}
                        {success && <p style={{ color: 'green' }}>{success}</p>}
                        <p />
                        <button type="submit">{t('Confirm')}</button>
                    </form>
                </div>
            </div>
            <Footer></Footer>
        </div>
    )
}

export default ResetPassword